import { forwardRef } from "react";

import type { LinkWrapperProps } from "./LinkBehaviourContext";
import { useLink } from "./LinkBehaviourContext";

export type LinkBehaviourProps = LinkWrapperProps & {
  nativeBehaviour?: boolean;
};

export const LinkBehaviour = forwardRef<HTMLAnchorElement, LinkBehaviourProps>(
  ({ children, nativeBehaviour, ...props }, ref) => {
    const LinkComponent = useLink();
    if (!LinkComponent || nativeBehaviour) {
      return (
        <a ref={ref} {...props}>
          {children}
        </a>
      );
    }
    return <LinkComponent {...props}>{children}</LinkComponent>;
  }
);

LinkBehaviour.displayName = "LinkBehaviour";
